// extracted by mini-css-extract-plugin
export default {"login":"SignInPage_login__pDG4b","ssoButton":"SignInPage_ssoButton__ntN1G"};